import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense, lazy, useEffect, useState } from "react";
import LockScreen from "./pages/LockScreen";

const UnlockedApp = lazy(() => import("./UnlockedApp"));

const queryClient = new QueryClient();

export const UNLOCK_DATE = new Date("2026-07-30T16:00:00");
const FORCE_SITE_LOCK = false;
const UNLOCK_STORAGE_KEY = "site-unlocked-v6";

const App = () => {
  const [isUnlocked, setIsUnlocked] = useState(() => {
    if (FORCE_SITE_LOCK) return localStorage.getItem(UNLOCK_STORAGE_KEY) === "true";
    if (new Date() >= UNLOCK_DATE) return true;
    return localStorage.getItem(UNLOCK_STORAGE_KEY) === "true";
  });

  const handleUnlock = () => {
    setIsUnlocked(true);
    localStorage.setItem(UNLOCK_STORAGE_KEY, "true");
  };

  useEffect(() => {
    if (isUnlocked || FORCE_SITE_LOCK) return;
    const ms = UNLOCK_DATE.getTime() - Date.now();
    if (ms <= 0) {
      handleUnlock();
      return;
    }
    const t = setTimeout(handleUnlock, ms);
    return () => clearTimeout(t);
  }, [isUnlocked]);

  if (!isUnlocked) {
    return (
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <LockScreen onUnlock={handleUnlock} />
        </TooltipProvider>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <UnlockedApp />
      </Suspense>
    </QueryClientProvider>
  );
};

export default App;
